import React, { useEffect, useState } from 'react'

import cached_10_jan_2025 from './static/cached_10_jan_2025.json'

import fake_people from './static/fake_people.json'

const Context = React.createContext();

var Airtable = require('airtable');


function Provider({ children }) {

  // Get auth token from localStorage
  const getAuthToken = () => localStorage.getItem('auth_token') || '';

  // Handle 401 errors - redirect to login
  const handle401 = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_expires');
    localStorage.removeItem('auth_user');
    window.location.href = '/login';
  };

  // Wrapper for fetch with auth and 401 handling
  const authFetch = async (url, options = {}) => {
    const token = getAuthToken();
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers,
    };

    const response = await fetch(url, { ...options, headers });

    if (response.status === 401) {
      handle401();
      throw new Error('Unauthorized');
    }

    return response;
  };


  // Функция для обработки заголовка
  const processTitle = (title) => {
    if (!title) return '';
    return title.trim();
  }

  // Функция для сортировки частей проекта по ID
  const processParts = (parts = []) => {
    return parts.sort((a, b) => {
      // Convert string IDs to numbers for proper sorting
      const aNum = parseInt(a.id, 10);
      const bNum = parseInt(b.id, 10);
      return aNum - bNum;
    });
  }



  // Утилиты для работы с URL параметрами
  const getUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      page: parseInt(params.get('page')) || 1,
      pageSize: parseInt(params.get('pageSize')) || 10,
      search: params.get('search') || '',
      sortField: params.get('sortField') || 'file_updated_at',
      sortOrder: params.get('sortOrder') || 'desc',
      assigneeFilter: params.get('assignee') || '',
      hasFinalVideoFilter: params.get('finalVideo') === 'true',
      translatedFilter: params.get('translated') === 'true',
      stageFilter: params.get('stage') || '',
      stageLang: params.get('stage_lang') || 'en',
      stageExclusive: params.get('stage_exclusive') === 'true'
    };
  };

  const updateUrl = (params) => {
    const url = new URL(window.location);
    // Обязательный параметр - номер страницы
    url.searchParams.set('page', params.page || 1);

    // Опциональные параметры - только если отличаются от дефолтных
    if (params.pageSize && params.pageSize !== 10) {
      url.searchParams.set('pageSize', params.pageSize);
    } else {
      url.searchParams.delete('pageSize');
    }

    if (params.search) {
      url.searchParams.set('search', params.search);
    } else {
      url.searchParams.delete('search');
    }

    if (params.sortField && params.sortField !== 'file_updated_at') {
      url.searchParams.set('sortField', params.sortField);
    } else {
      url.searchParams.delete('sortField');
    }

    if (params.sortOrder && params.sortOrder !== 'desc') {
      url.searchParams.set('sortOrder', params.sortOrder);
    } else {
      url.searchParams.delete('sortOrder');
    }

    if (params.assigneeFilter) {
      url.searchParams.set('assignee', params.assigneeFilter);
    } else {
      url.searchParams.delete('assignee');
    }

    if (params.hasFinalVideoFilter) {
      url.searchParams.set('finalVideo', 'true');
    } else {
      url.searchParams.delete('finalVideo');
    }

    if (params.translatedFilter) {
      url.searchParams.set('translated', 'true');
    } else {
      url.searchParams.delete('translated');
    }

    if (params.stageFilter) {
      url.searchParams.set('stage', params.stageFilter);
    } else {
      url.searchParams.delete('stage');
    }

    if (params.stageLang && params.stageLang !== 'en') {
      url.searchParams.set('stage_lang', params.stageLang);
    } else {
      url.searchParams.delete('stage_lang');
    }

    if (params.stageExclusive) {
      url.searchParams.set('stage_exclusive', 'true');
    } else {
      url.searchParams.delete('stage_exclusive');
    }

    window.history.pushState({}, '', url);
  };

  // Инициализация состояния из URL
  const urlParams = getUrlParams();

  const [data, setData] = useState([])
  const [people, setPeople] = useState([])

  // Pagination state
  const [currentPage, setCurrentPage] = useState(urlParams.page);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(urlParams.pageSize);
  const [isLoading, setIsLoading] = useState(false);

  const [projects, setProjects] = useState([])
  const [langsShown, setLangsShown] = useState('all');

  // Search and sort state
  const [searchQuery, setSearchQuery] = useState(urlParams.search);
  const [sortField, setSortField] = useState(urlParams.sortField);
  const [sortOrder, setSortOrder] = useState(urlParams.sortOrder);
  const [assigneeFilter, setAssigneeFilter] = useState(urlParams.assigneeFilter);
  const [hasFinalVideoFilter, setHasFinalVideoFilter] = useState(urlParams.hasFinalVideoFilter);
  const [translatedFilter, setTranslatedFilter] = useState(urlParams.translatedFilter);
  const [stageFilter, setStageFilter] = useState(urlParams.stageFilter);
  const [stageLang, setStageLang] = useState(urlParams.stageLang);
  const [stageExclusive, setStageExclusive] = useState(urlParams.stageExclusive);
  // Multi-select for the bulk «Обработать → опубликовать» action (media_id Set).
  const [selectedIds, setSelectedIds] = useState(() => new Set());
  const [totalItems, setTotalItems] = useState(0);

  // Функция для сохранения данных в localStorage
  const saveDataToStorage = (dataToSave) => {
    try {
      localStorage.setItem('translation_hub_projects', JSON.stringify({
        data: dataToSave,
        timestamp: new Date().toISOString()
      }));
    } catch (error) {
      console.error('Error saving data to localStorage:', error);
    }
  };

  // Функция для загрузки данных из localStorage
  const loadDataFromStorage = () => {
    try {
      const stored = localStorage.getItem('translation_hub_projects');
      if (stored) {
        const parsed = JSON.parse(stored);
        // Проверяем, что данные не старше 1 часа
        const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000);
        const storedTime = new Date(parsed.timestamp);

        if (storedTime > oneHourAgo) {
          return parsed.data;
        }
      }
    } catch (error) {
      console.error('Error loading data from localStorage:', error);
    }
    return null;
  };

  // @deprecated — dead code. The live list uses fetchProjectsWithFilters (GET /projects/).
  // fetchData / fetchProjectsByPage / fetchTotalPages (GET /projects/pages/{n}, /total_pages)
  // are not called by any mounted component; kept only to avoid breaking the exported shape.
  const fetchData = async () => {
    try {
      // Use the pagination system instead of hardcoded page 1
      await fetchProjectsByPage(1, pageSize);
    } catch (error) {
      console.error('Error fetching projects:', error);
      // Fallback to cached data if API fails
      setData([]);
    }
  };

  // Метод для получения данных одного проекта
  const fetchProjectById = async (projectId) => {
    try {
      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/full_data`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        let detail = `HTTP error! status: ${response.status}`;
        try {
          const errBody = await response.json();
          if (errBody.detail) detail = errBody.detail;
        } catch (_) {}
        throw new Error(detail);
      }

      const result = await response.json();
      // Возвращаем полные данные проекта в новой структуре
      return {
        '_id': result.id,
        'id': result.id,
        'name': result.name,
        'source_file': result.source_file,
        'upload_full_video_languages': result.upload_full_video_languages,
        'parts': processParts(result.parts || []),
        'project_archived': false,
        'fileDate': new Date().toISOString(),
        'ref_id': '',
        'file_video_title': result.name,
        'title_rus': result.name,
        'proofread_assignee': [],
        'proofread_status': [],
        'ref_proofread_assignee': [],
        'proofread_date_start': '',
        'subtitles_assignee': '',
        'subtitles_status': [],
        'subtitles_date_start': '',
        'subtitles_check_assignee': '',
        'subtitles_check_start_date': '',
        'translate_assignee': [],
        'translate_start_date': '',
        'translate_check_assignee': '',
        'translate_check_start_date': '',
      };
    } catch (error) {
      console.error('Error fetching project by ID:', error.message || error);
      return null;
    }
  };

  // Метод для получения общего количества страниц
  const fetchTotalPages = async () => {
    try {
      const response = await fetch('https://translation-manag-server.dev.torsunov.pro/projects/total_pages', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setTotalPages(result.total_pages || 0);
      return result.total_pages || 0;
    } catch (error) {
      console.error('Error fetching total pages:', error);
      setTotalPages(0);
      return 0;
    }
  };

  // Метод для получения проектов с пагинацией
  const fetchProjectsByPage = async (page = 1, size = pageSize) => {
    setIsLoading(true);
    try {
      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/pages/${page}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      const processedData = result.map(project => ({
        '_id': project.id,
        'id': project.id,
        'name': project.name,
        'source_file': project.source_file,
        'upload_full_video_languages': project.upload_full_video_languages,
        'parts': processParts(project.parts || []),
        'project_archived': false,
        'fileDate': new Date().toISOString(),
        'file_video_title': project.name,
        ...project
      }));

      setData(processedData);
      setCurrentPage(page);
      setPageSize(size);
      return processedData;
    } catch (error) {
      console.error('Error fetching projects by page:', error);
      setData([]);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  // Метод для получения проектов с фильтрами и сортировкой (новый API)
  const fetchProjectsWithFilters = async (page = 1, size = pageSize, filters = {}, sort_by = sortField, sort_order = sortOrder, includeDetails = false) => {
    setIsLoading(true);
    try {
      // Построение URL с query parameters
      const params = new URLSearchParams({
        page: page.toString(),
        per_page: size.toString(),
        sort_by: sort_by,
        sort_order: sort_order,
        include_details: includeDetails.toString(),
      });

      // Добавляем фильтры, если они есть
      if (filters.name) {
        params.append('name', filters.name);
      }
      if (filters.source_file) {
        params.append('source_file', filters.source_file);
      }
      if (filters.language_id) {
        params.append('language_id', filters.language_id);
      }
      if (filters.status) {
        params.append('status', filters.status);
      }
      if (filters.assignee_id) {
        params.append('assignee_id', filters.assignee_id);
      }
      if (filters.has_final_video) {
        params.append('has_final_video', 'true');
      }
      if (filters.translated) {
        params.append('translated', 'true');
      }
      if (filters.stage_done) {
        params.append('stage_done', filters.stage_done);
      }
      if (filters.stage_exclusive) {
        params.append('stage_exclusive', 'true');
      }
      if (filters.published_site) {
        params.append('published_site', 'true');
      }
      if (filters.published_yt) {
        params.append('published_yt', 'true');
      }
      if (filters.stage_lang) {
        params.append('stage_lang', filters.stage_lang);
      }

      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      const processedData = result.items.map(project => ({
        '_id': project.id,
        'id': project.id,
        'name': project.name,
        'source_file': project.source_file,
        'upload_full_video_languages': project.upload_full_video_languages,
        'parts': processParts(project.parts || []),
        'parts_count': project.parts_count || (project.parts ? project.parts.length : 0),
        'available_languages': project.available_languages || [],
        'project_archived': false,
        'fileDate': new Date().toISOString(),
        'file_video_title': project.name,
        'title_rus': project.name,
        'detailsLoaded': includeDetails, // Флаг загружены ли детали
        ...project
      }));

      setData(processedData);
      setCurrentPage(result.page);
      setTotalPages(result.total_pages);
      setTotalItems(result.total || 0);
      setPageSize(result.per_page);
      return {
        items: processedData,
        total: result.total,
        page: result.page,
        per_page: result.per_page,
        total_pages: result.total_pages
      };
    } catch (error) {
      console.error('Error fetching projects with filters:', error);
      setData([]);
      setTotalItems(0);
      return {
        items: [],
        total: 0,
        page: 1,
        per_page: size,
        total_pages: 0
      };
    } finally {
      setIsLoading(false);
    }
  };

  // Вспомогательная функция для построения фильтров
  const buildFilters = (query = searchQuery, assignee = assigneeFilter, finalVideo = hasFinalVideoFilter, translatedOnly = translatedFilter, stage = stageFilter, lang = stageLang, langHas = langsShown, exclusive = stageExclusive) => {
    const filters = {};
    if (query) {
      filters.name = query;
    }
    if (assignee) {
      filters.assignee_id = assignee;
    }
    if (finalVideo) {
      filters.has_final_video = true;
    }
    if (stage) {
      if (stage === 'published_site') filters.published_site = true;
      else if (stage === 'published_yt') filters.published_yt = true;
      else {
        filters.stage_done = stage; // a work_type name (auto_translation, voicing, ...)
        // "Only at this stage": this stage done but the next pipeline stage NOT done (intermediate view,
        // e.g. translated-but-not-checked). Only meaningful for real work-type stages, not publish flags.
        if (exclusive) filters.stage_exclusive = true;
      }
      filters.stage_lang = lang || 'en';
    }
    if (translatedOnly) {
      filters.translated = true;
    }
    // Top language chips: filter the list to lectures that HAVE the chosen language ('all' = no filter).
    if (langHas && langHas !== 'all') {
      filters.has_lang = langHas;
    }
    return filters;
  };

  // Метод для изменения размера страницы
  const changePageSize = async (newPageSize) => {
    setPageSize(newPageSize);
    // Reset to first page when changing page size
    const filters = buildFilters();
    updateUrl({ page: 1, pageSize: newPageSize, search: searchQuery, sortField, sortOrder, assigneeFilter });
    await fetchProjectsWithFilters(1, newPageSize, filters, sortField, sortOrder);
  };

  // Метод для перехода на следующую страницу
  const nextPage = async () => {
    if (currentPage < totalPages) {
      const filters = buildFilters();
      updateUrl({ page: currentPage + 1, pageSize, search: searchQuery, sortField, sortOrder, assigneeFilter });
      await fetchProjectsWithFilters(currentPage + 1, pageSize, filters, sortField, sortOrder);
    }
  };

  // Метод для перехода на предыдущую страницу
  const prevPage = async () => {
    if (currentPage > 1) {
      const filters = buildFilters();
      updateUrl({ page: currentPage - 1, pageSize, search: searchQuery, sortField, sortOrder, assigneeFilter });
      await fetchProjectsWithFilters(currentPage - 1, pageSize, filters, sortField, sortOrder);
    }
  };

  // Метод для перехода на конкретную страницу
  const goToPage = async (page) => {
    if (page >= 1 && page <= totalPages) {
      const filters = buildFilters();
      updateUrl({ page, pageSize, search: searchQuery, sortField, sortOrder, assigneeFilter });
      await fetchProjectsWithFilters(page, pageSize, filters, sortField, sortOrder);
    }
  };

  // Метод для получения информации о пагинации
  const getPaginationInfo = () => {
    return {
      currentPage,
      totalPages,
      pageSize,
      isLoading,
      hasNextPage: currentPage < totalPages,
      hasPrevPage: currentPage > 1,
      totalItems: totalItems
    };
  };

  useEffect(() => {
    // Initialize pagination system with URL params
    const initializePagination = async () => {
      try {
        // Use params from URL
        const filters = buildFilters();
        await fetchProjectsWithFilters(currentPage, pageSize, filters, sortField, sortOrder, false);
      } catch (error) {
        console.error('Error initializing pagination:', error);
        setData([]);
      } finally {
        setReady(true);
      }
    };

    initializePagination();
  }, []);

  // Метод для получения пользователей с API
  const fetchPeople = async () => {
    try {
      const response = await fetch('https://translation-manag-server.dev.torsunov.pro/users', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // Map API data to match the expected structure
      const mappedPeople = result.map(person => ({
        id: person.id,
        name: person.name,
        email: person.email,
        emailVerified: person.emailVerified,
        role: person.role,
        isVerifyByAdmin: person.isVerifyByAdmin,
        groupName: person.groupName
      }));

      setPeople(mappedPeople);
      return mappedPeople;
    } catch (error) {
      console.error('Error fetching people:', error);
      // Fallback to fake data if API fails
      setPeople(fake_people);
      return fake_people;
    }
  };

  // Fetch people on component mount
  useEffect(() => {
    fetchPeople();
  }, []);

  const [ready, setReady] = useState(false)




  const getProjectsByHandle = (handle) => {
    // В новой структуре данных нет прямых полей assignee
    // Возвращаем все проекты, так как структура изменилась
    return data.filter(one =>
      one.name && one.name.toLowerCase().includes(handle.toLowerCase())
    );
  }

  const getProjectById = (id) => {
    return data.find(one => one._id === id || one.id === id);
  }

  // Новый метод для поиска проектов по названию
  const getProjectsByName = (name) => {
    return data.filter(one =>
      one.name && one.name.toLowerCase().includes(name.toLowerCase())
    );
  }

  // Новый метод для получения всех частей проекта
  const getProjectParts = (projectId) => {
    const project = getProjectById(projectId);
    return project ? project.parts || [] : [];
  }

  // Новый метод для получения языков проекта
  const getProjectLanguages = (projectId) => {
    const parts = getProjectParts(projectId);
    const languages = new Set();
    parts.forEach(part => {
      if (part.languages) {
        part.languages.forEach(lang => {
          languages.add(lang.id);
        });
      }
    });
    return Array.from(languages);
  }

  // Новый метод для получения статусов задач проекта
  const getProjectTaskStatuses = (projectId) => {
    const parts = getProjectParts(projectId);
    const statuses = {
      auto_translation: [],
      translation_proofreading: [],
      voicing: [],
      voicing_proofreading: [],
      animations_video: [],
      animations_video_proofreading: [],
      video: [],
      video_proofreading: [],
      full_video: [],
      full_video_proofreading: [],
      ts_playlist: [],
      loading_in_s3: []
    };

    parts.forEach(part => {
      if (part.languages) {
        part.languages.forEach(lang => {
          Object.keys(statuses).forEach(taskType => {
            if (lang[taskType] && lang[taskType].status) {
              statuses[taskType].push({
                part_id: part.id,
                language: lang.id,
                status: lang[taskType].status,
                assignee: lang[taskType].assignee,
                date: lang[taskType].date,
                file: lang[taskType].file
              });
            }
          });
        });
      }
    });

    return statuses;
  }

  // Метод для очистки кэша localStorage
  const clearCache = () => {
    try {
      localStorage.removeItem('translation_hub_projects');
      console.log('Cache cleared');
    } catch (error) {
      console.error('Error clearing cache:', error);
    }
  };

  // Метод для обновления одного проекта (быстрое обновление без потери состояния)
  const refreshProject = async (projectId) => {
    try {
      const fullProjectData = await fetchProjectById(projectId);

      if (fullProjectData) {
        // Обновляем только этот проект в существующем списке
        setData(prevData => {
          return prevData.map(project => {
            if (project.id === projectId || project._id === projectId) {
              return {
                ...project,
                parts: processParts(fullProjectData.parts || []),
                detailsLoaded: true,
                // Обновляем все поля из API
                ...fullProjectData,
                '_id': fullProjectData.id,
                'id': fullProjectData.id,
              };
            }
            return project;
          });
        });
        return fullProjectData;
      }
      return null;
    } catch (error) {
      console.error('Error refreshing project:', error);
      return null;
    }
  };

  // Метод для принудительного обновления всех данных (с сохранением состояния)
  const refreshData = async () => {
    try {
      // Сохраняем текущее состояние
      const filters = buildFilters();
      // Перезагружаем с текущими параметрами
      await fetchProjectsWithFilters(currentPage, pageSize, filters, sortField, sortOrder, false);
    } catch (error) {
      console.error('Error refreshing data:', error);
    }
  };

  // Метод для обновления статуса задачи
  // currentTask - опциональный параметр с текущими данными задачи (для получения id существующего статуса)
  const updateTaskStatus = async (projectId, partId, languageId, taskType, status, assigneeId, currentTask = null) => {
    try {
      // Извлекаем id исполнителя - assignee может быть объектом {id, email} или строкой id
      const currentAssigneeId = typeof currentTask?.assignee === 'object'
        ? currentTask?.assignee?.id
        : currentTask?.assignee;

      const currentDate = new Date().toISOString();
      // Устанавливаем assigned_at когда статус становится in_progress (если ещё не установлен)
      const assignedAt = (status === 'in_progress' && !currentTask?.assigned_at)
        ? currentDate
        : (currentTask?.assigned_at || null);
      // Устанавливаем completed_at только когда статус становится done
      const completedAt = status === 'done' ? currentDate : null;

      // Используем API update_language_field - не требует полных данных проекта
      const statusData = {
        id: currentTask?.id || null, // Используем существующий id если есть, иначе создастся новый
        assignee: assigneeId || currentAssigneeId || null,
        status: status,
        date: currentDate,
        file: currentTask?.file || null,
        // assigned_at устанавливается при статусе in_progress, иначе сохраняется
        assigned_at: assignedAt,
        // completed_at устанавливается при статусе done, иначе сбрасывается
        completed_at: completedAt
      };

      const requestBody = {
        language_id: languageId,
        part_id: partId,
        project_id: projectId,
        field_name: taskType,
        status_data: statusData
      };

      const response = await fetch('https://translation-manag-server.dev.torsunov.pro/languages/update_language_field', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Status update successful:', result);

      // При сортировке по дате изменений - перезагружаем весь список для корректной сортировки
      // Иначе - обновляем только этот проект (быстрее)
      if (sortField === 'status_date') {
        await refreshData();
      } else {
        await refreshProject(projectId);
      }

      return result;
    } catch (error) {
      console.error('Error updating task status:', error);
      throw error;
    }
  };

  // Метод для обновления назначения задачи
  // currentTask - опциональный параметр с текущими данными задачи
  const updateTaskAssignee = async (projectId, partId, languageId, taskType, assigneeId, currentTask = null) => {
    try {
      const currentDate = new Date().toISOString();
      // Определяем, изменился ли назначенный пользователь
      const isNewAssignment = !currentTask?.assignee?.id || currentTask.assignee.id !== assigneeId;

      // Используем API update_language_field - не требует полных данных проекта
      const statusData = {
        id: currentTask?.id || null, // Используем существующий id если есть
        assignee: assigneeId,
        status: currentTask?.status || 'pending', // Сохраняем текущий статус или ставим pending
        date: currentDate,
        file: currentTask?.file || null,
        // Устанавливаем assigned_at только при новом назначении
        assigned_at: isNewAssignment ? currentDate : (currentTask?.assigned_at || null),
        // Сохраняем существующую дату завершения
        completed_at: currentTask?.completed_at || null
      };

      const requestBody = {
        language_id: languageId,
        part_id: partId,
        project_id: projectId,
        field_name: taskType,
        status_data: statusData
      };

      const response = await fetch('https://translation-manag-server.dev.torsunov.pro/languages/update_language_field', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Assignee update successful:', result);

      // При сортировке по дате изменений - перезагружаем весь список для корректной сортировки
      if (sortField === 'status_date') {
        await refreshData();
      } else {
        await refreshProject(projectId);
      }

      return result;
    } catch (error) {
      console.error('Error updating task assignee:', error);
      throw error;
    }
  };

  // Метод для массового назначения исполнителя на части проекта (с поддержкой диапазона)
  const bulkAssignTaskType = async (projectId, taskType, assigneeId, languageId, partFrom = null, partTo = null, skipRefresh = false) => {
    if (!languageId) {
      throw new Error('language_id is required');
    }

    try {
      const requestBody = {
        project_id: projectId,
        task_type: taskType,
        assignee_id: assigneeId,
        language_id: languageId,
      };

      // Добавляем диапазон частей, если указан
      if (partFrom !== null) {
        requestBody.part_from = partFrom;
      }
      if (partTo !== null) {
        requestBody.part_to = partTo;
      }

      const response = await fetch('https://translation-manag-server.dev.torsunov.pro/languages/assign_all_parts', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail?.message || errorData.detail?.error || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Assign all parts successful:', result);

      // Refresh project data to show updated assignments
      if (!skipRefresh) {
        await refreshProject(projectId);
      }

      return result;
    } catch (error) {
      console.error('Error assigning to all parts:', error);
      throw error;
    }
  };

  // Метод для массового обновления статуса на части проекта (с поддержкой диапазона)
  const bulkUpdateStatus = async (projectId, taskType, status, languageId, partFrom = null, partTo = null, skipRefresh = false) => {
    if (!languageId) {
      throw new Error('language_id is required');
    }

    if (!status) {
      throw new Error('status is required');
    }

    try {
      const requestBody = {
        project_id: projectId,
        task_type: taskType,
        status: status,
        language_id: languageId,
      };

      // Добавляем диапазон частей, если указан
      if (partFrom !== null) {
        requestBody.part_from = partFrom;
      }
      if (partTo !== null) {
        requestBody.part_to = partTo;
      }

      const response = await fetch('https://translation-manag-server.dev.torsunov.pro/languages/bulk_update_status', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail?.message || errorData.detail?.error || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Bulk update status successful:', result);

      // Refresh project data to show updated statuses
      if (!skipRefresh) {
        await refreshProject(projectId);
      }

      return result;
    } catch (error) {
      console.error('Error bulk updating status:', error);
      throw error;
    }
  };

  const fetchProjectFullData = async (projectId) => {
    try {
      console.log(`[ProjectData] Загрузка данных проекта ${projectId}...`);

      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/full_data`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        // Если данных нет в БД - пробуем синхронизировать с диска
        if (response.status === 404) {
          console.log(`[ProjectData] Проект ${projectId} не найден в БД, пробуем синхронизировать с диска...`);

          const lectureResult = await getLectureDataWithSync(projectId);

          if (lectureResult.data) {
            console.log(`%c[ProjectData] Данные синхронизированы с диска!`, 'color: #52c41a; font-weight: bold');
            // Добавляем флаг синхронизации к данным
            return {
              ...lectureResult.data,
              _syncedFromDisk: true,
              _syncDetails: lectureResult.sync_details
            };
          } else {
            console.warn(`[ProjectData] Не удалось получить данные: ${lectureResult.source}`);
            return null;
          }
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Проверяем есть ли части - если нет, возможно нужна синхронизация
      if (!data.parts || data.parts.length === 0) {
        console.log(`[ProjectData] У проекта ${projectId} нет частей, проверяем диск...`);

        const syncResult = await syncLectureData(projectId);

        if (syncResult.fixes_applied && syncResult.fixes_applied.length > 0) {
          console.log(`%c[ProjectData] Синхронизация применила ${syncResult.fixes_applied.length} исправлений`, 'color: #52c41a; font-weight: bold');

          // Перезагружаем данные после синхронизации
          const refreshResponse = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/full_data`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${getAuthToken()}`,
              'Content-Type': 'application/json',
            },
          });

          if (refreshResponse.ok) {
            const refreshedData = await refreshResponse.json();
            return {
              ...refreshedData,
              _syncedFromDisk: true,
              _syncDetails: syncResult
            };
          }
        }
      }

      return data;
    } catch (error) {
      console.error('[ProjectData] Ошибка загрузки данных проекта:', error);
      return null;
    }
  };

  // Методы для работы с поиском и сортировкой
  const handleSearch = async (query, searchType = 'name') => {
    setSearchQuery(query);
    updateUrl({ page: 1, pageSize, search: query, sortField, sortOrder, assigneeFilter });

    // Если ищем по ID - получаем проект напрямую
    if (query && searchType === 'id') {
      setIsLoading(true);
      try {
        const project = await fetchProjectById(query);
        if (project) {
          setData([project]);
          setCurrentPage(1);
          setTotalPages(1);
        } else {
          setData([]);
          setTotalPages(0);
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      // Иначе ищем по названию
      const filters = buildFilters(query, assigneeFilter);
      await fetchProjectsWithFilters(1, pageSize, filters, sortField, sortOrder, false);
    }
  };

  const handleSort = async (field, order) => {
    setSortField(field);
    setSortOrder(order);
    const filters = buildFilters();
    updateUrl({ page: currentPage, pageSize, search: searchQuery, sortField: field, sortOrder: order, assigneeFilter });
    await fetchProjectsWithFilters(currentPage, pageSize, filters, field, order, false);
  };

  // Метод для фильтрации по исполнителю
  const handleAssigneeFilter = async (assigneeId) => {
    setAssigneeFilter(assigneeId);
    updateUrl({ page: 1, pageSize, search: searchQuery, sortField, sortOrder, assigneeFilter: assigneeId });
    const filters = buildFilters(searchQuery, assigneeId);
    await fetchProjectsWithFilters(1, pageSize, filters, sortField, sortOrder, false);
  };

  const resetFilters = async () => {
    setSearchQuery('');
    setSortField('file_updated_at');
    setSortOrder('desc');
    setAssigneeFilter('');
    setHasFinalVideoFilter(false);
    setTranslatedFilter(false);
    setStageFilter('');
    setStageLang('en');
    setStageExclusive(false);
    setLangsShown('all');
    updateUrl({ page: 1, pageSize: 10, search: '', sortField: 'file_updated_at', sortOrder: 'desc', assigneeFilter: '', hasFinalVideoFilter: false, translatedFilter: false, stageFilter: '', stageLang: 'en' });
    await fetchProjectsWithFilters(1, pageSize, {}, 'file_updated_at', 'desc', false);
  };

  // Метод для фильтрации по наличию финального видео
  const handleFinalVideoFilter = async (value) => {
    setHasFinalVideoFilter(value);
    const filters = buildFilters(searchQuery, assigneeFilter, value);
    updateUrl({ page: 1, pageSize, search: searchQuery, sortField, sortOrder, assigneeFilter, hasFinalVideoFilter: value, translatedFilter, stageFilter });
    await fetchProjectsWithFilters(1, pageSize, filters, sortField, sortOrder, false);
  };

  // Метод для фильтрации по этапу обработки (перевод/правка/озвучка/видео/публикация)
  const handleStageFilter = async (value) => {
    const v = value || '';
    setStageFilter(v);
    const filters = buildFilters(searchQuery, assigneeFilter, hasFinalVideoFilter, translatedFilter, v, stageLang);
    updateUrl({ page: 1, pageSize, search: searchQuery, sortField, sortOrder, assigneeFilter, hasFinalVideoFilter, translatedFilter, stageFilter: v, stageLang, stageExclusive });
    await fetchProjectsWithFilters(1, pageSize, filters, sortField, sortOrder, false);
  };

  // Метод для выбора языка для фильтра по этапу (перевод/озвучка/видео/публикация — по языку)
  const handleStageLang = async (lang) => {
    const l = lang || 'en';
    setStageLang(l);
    const filters = buildFilters(searchQuery, assigneeFilter, hasFinalVideoFilter, translatedFilter, stageFilter, l);
    updateUrl({ page: 1, pageSize, search: searchQuery, sortField, sortOrder, assigneeFilter, hasFinalVideoFilter, translatedFilter, stageFilter, stageLang: l, stageExclusive });
    await fetchProjectsWithFilters(1, pageSize, filters, sortField, sortOrder, false);
  };

  // «Только на этом этапе»: показать лекции РОВНО на выбранном этапе (этап done, но следующий — нет).
  const handleStageExclusive = async (checked) => {
    const ex = !!checked;
    setStageExclusive(ex);
    const filters = buildFilters(searchQuery, assigneeFilter, hasFinalVideoFilter, translatedFilter, stageFilter, stageLang, langsShown, ex);
    updateUrl({ page: 1, pageSize, search: searchQuery, sortField, sortOrder, assigneeFilter, hasFinalVideoFilter, translatedFilter, stageFilter, stageLang, stageExclusive: ex });
    await fetchProjectsWithFilters(1, pageSize, filters, sortField, sortOrder, false);
  };

  // ===== Bulk «Обработать → опубликовать» (mass full-cycle + optional clip recut) =====
  const MANAG_API = 'https://translation-manag-server.dev.torsunov.pro';

  // Build the /projects/filter_ids query params from the CURRENT filter state (mirrors buildFilters).
  const buildFilterQueryParams = () => {
    const p = new URLSearchParams();
    if (searchQuery) p.append('name', searchQuery);
    if (assigneeFilter) p.append('assignee_id', assigneeFilter);
    if (translatedFilter) p.append('translated', 'true');
    if (stageFilter) {
      if (stageFilter === 'published_site') p.append('published_site', 'true');
      else if (stageFilter === 'published_yt') p.append('published_yt', 'true');
      else {
        p.append('stage_done', stageFilter);
        if (stageExclusive) p.append('stage_exclusive', 'true');
      }
      p.append('stage_lang', stageLang || 'en');
    }
    if (langsShown && langsShown !== 'all') p.append('has_lang', langsShown);
    if (hasFinalVideoFilter) p.append('has_final_video', 'true');
    return p;
  };

  const fetchFilterIds = async () => {
    const p = buildFilterQueryParams();
    const res = await authFetch(`${MANAG_API}/projects/filter_ids?${p.toString()}`);
    if (!res.ok) throw new Error('filter_ids failed');
    return await res.json(); // { media_ids: [...], total }
  };

  const toggleSelect = (id) => {
    setSelectedIds(prev => {
      const n = new Set(prev);
      if (n.has(id)) n.delete(id); else n.add(id);
      return n;
    });
  };
  const selectPageIds = (ids = []) => setSelectedIds(prev => new Set([...prev, ...ids]));
  const clearSelection = () => setSelectedIds(new Set());
  const selectAllMatchingFilter = async () => {
    const data = await fetchFilterIds();
    setSelectedIds(new Set(data.media_ids || []));
    return data.total || 0;
  };

  // POST the bulk job to the manag-server proxy (-> mass_full_cycle + optional clip recut).
  const massProcess = async (opts) => {
    const res = await authFetch(`${MANAG_API}/projects/mass_process`, {
      method: 'POST',
      body: JSON.stringify(opts),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.detail || 'mass_process failed');
    return data;
  };

  // Метод для фильтра по языку (верхние чипсы «Все · Ru · En · …») — показывает только лекции, у которых
  // ЕСТЬ этот язык, и синхронизирует язык этапа. 'all' — снять фильтр.
  const handleLangFilter = async (langValue) => {
    const l = langValue || 'all';
    setLangsShown(l);
    const sl = l === 'all' ? stageLang : l;
    if (l !== 'all') setStageLang(l);
    const filters = buildFilters(searchQuery, assigneeFilter, hasFinalVideoFilter, translatedFilter, stageFilter, sl, l);
    updateUrl({ page: 1, pageSize, search: searchQuery, sortField, sortOrder, assigneeFilter, hasFinalVideoFilter, translatedFilter, stageFilter, stageLang: sl });
    await fetchProjectsWithFilters(1, pageSize, filters, sortField, sortOrder, false);
  };

  // Метод для фильтрации «только переведённые» (EN auto_translation done)
  const handleTranslatedFilter = async (value) => {
    setTranslatedFilter(value);
    const filters = buildFilters(searchQuery, assigneeFilter, hasFinalVideoFilter, value);
    updateUrl({ page: 1, pageSize, search: searchQuery, sortField, sortOrder, assigneeFilter, hasFinalVideoFilter, translatedFilter: value });
    await fetchProjectsWithFilters(1, pageSize, filters, sortField, sortOrder, false);
  };

  // Метод для разделения видео на части
  const splitVideo = async (projectId) => {
    try {
      console.log('splitVideo called with projectId:', projectId);

      const formData = new URLSearchParams();
      formData.append('project_id', projectId);

      const response = await fetch('https://translation-manag-server.dev.torsunov.pro/projects/split', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Split video successful:', result);
      return result;
    } catch (error) {
      console.error('Error splitting video:', error);
      throw error;
    }
  };

  // Метод для создания папки translate and synt audio
  const createFolderTranslateAndSynt = async (projectId, options) => {
    try {
      const {
        folder_nums,
        lang,
        language_from,
        create_synt_audio,
        translation_model,
        speed_synt_audio,
        re_creation_synt_audio,
        re_creation_translate
      } = options;

      const params = new URLSearchParams({ media: projectId });
      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/folder_create_translate_and_synt_audio?${params.toString()}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          folder_nums,
          lang,
          language_from,
          create_synt_audio,
          translation_model,
          speed_synt_audio,
          re_creation_synt_audio,
          re_creation_translate
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Create folder translate and synt successful:', result);
      return result;
    } catch (error) {
      console.error('Error creating folder translate and synt:', error);
      throw error;
    }
  };

  // Метод для получения статуса задач проекта
  const getTaskStatus = async (projectId) => {
    try {
      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/task_status`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          return { tasks: {} }; // No tasks yet
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error fetching task status:', error);
      return { tasks: {} };
    }
  };

  // Метод для склейки видео и аудио для папок (folder_merge_wavs_and_video)
  const folderMergeWavsAndVideo = async (projectId, options) => {
    try {
      const { lang, folder_nums, create_merge_mp4_wav_folder = false } = options;

      const params = new URLSearchParams({ media: projectId });
      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/folder_merge_wavs_and_video?${params.toString()}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          lang,
          folder_nums,
          create_merge_mp4_wav_folder
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Folder merge wavs and video successful:', result);
      return result;
    } catch (error) {
      console.error('Error in folder merge wavs and video:', error);
      throw error;
    }
  };

  // Метод для создания видео без пауз (cut_without_pauses)
  const cutWithoutPauses = async (projectId, options) => {
    try {
      const { folder_num, lang } = options;

      const params = new URLSearchParams({ media: projectId });

      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/cut_without_pauses?${params.toString()}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ folder_num, lang }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Cut without pauses successful:', result);
      return result;
    } catch (error) {
      console.error('Error in cut without pauses:', error);
      throw error;
    }
  };

  // Метод для склейки полного видео без пауз (create_max_without_pauses_video)
  const createMaxWithoutPausesVideo = async (projectId, options) => {
    try {
      const { lang, do_validate_completeness = false, force_recreate = false, end_folder = null } = options;

      const params = new URLSearchParams({
        media: projectId,
        lang,
        do_validate_completeness: do_validate_completeness.toString(),
        force_recreate: force_recreate.toString()
      });

      if (end_folder !== null) {
        params.append('end_folder', end_folder.toString());
      }

      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/create_max_without_pauses_video?${params.toString()}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Create max without pauses video successful:', result);
      return result;
    } catch (error) {
      console.error('Error in create max without pauses video:', error);
      throw error;
    }
  };

  // Метод для синхронизации данных лекции с диска в БД
  const syncLectureData = async (projectId) => {
    try {
      console.log(`[SyncLecture] Запуск синхронизации для проекта ${projectId}...`);

      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/sync_diff`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      // Логирование результатов в консоль
      if (result.summary) {
        console.log(`[SyncLecture] Синхронизация завершена для проекта ${projectId}:`);
        console.log(`  - Найдено расхождений: ${result.summary.differences_found}`);
        console.log(`  - Применено исправлений: ${result.summary.fixes_applied}`);
        console.log(`  - Ошибок: ${result.summary.errors}`);
      }

      if (result.fixes_applied && result.fixes_applied.length > 0) {
        console.log('[SyncLecture] Применённые исправления:', result.fixes_applied);
      }

      if (result.errors && result.errors.length > 0) {
        console.warn('[SyncLecture] Ошибки при синхронизации:', result.errors);
      }

      return result;
    } catch (error) {
      console.error('[SyncLecture] Ошибка синхронизации:', error);
      return { errors: [error.message] };
    }
  };

  // Метод для получения данных лекции с автоматической синхронизацией
  const getLectureDataWithSync = async (projectId) => {
    try {
      console.log(`[LectureData] Получение данных для проекта ${projectId}...`);

      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/lecture_data`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      // Логирование в консоль
      console.log(`[LectureData] Источник данных: ${result.source}`);

      if (result.synced) {
        console.log(`[LectureData] Данные были синхронизированы с диска!`);
        if (result.sync_details) {
          console.log(`  - Создано частей: ${result.sync_details.parts_created || 0}`);
          console.log(`  - Создано языков: ${result.sync_details.languages_created || 0}`);
        }
      }

      if (result.source === 'not_found') {
        console.warn(`[LectureData] Проект ${projectId} не найден ни в БД, ни на диске`);
      } else if (result.source === 'disk_incomplete') {
        console.warn(`[LectureData] Данные на диске неполные:`, result.sync_details?.error);
      } else if (result.source === 'sync_failed') {
        console.error(`[LectureData] Ошибка синхронизации:`, result.sync_details?.error);
      }

      return result;
    } catch (error) {
      console.error('[LectureData] Ошибка получения данных:', error);
      return { source: 'error', error: error.message };
    }
  };

  // Метод для сканирования диска (без изменения БД)
  const scanLectureOnDisk = async (projectId) => {
    try {
      console.log(`[ScanDisk] Сканирование диска для проекта ${projectId}...`);

      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/scan_disk`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      console.log(`[ScanDisk] Результат сканирования:`);
      console.log(`  - Папка существует: ${result.exists}`);
      console.log(`  - Папка subs: ${result.has_subs_folder}`);
      console.log(`  - Частей найдено: ${Object.keys(result.parts || {}).length}`);

      if (result.project_info) {
        console.log(`  - Имя проекта: ${result.project_info.name}`);
      }

      return result;
    } catch (error) {
      console.error('[ScanDisk] Ошибка сканирования:', error);
      return { exists: false, error: error.message };
    }
  };

  // Метод для получения ссылок на скачивание результатов задач
  const getDownloadLinks = async (projectId, lang = null) => {
    try {
      const params = new URLSearchParams();
      if (lang) {
        params.append('lang', lang);
      }

      const url = `https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/download_links${params.toString() ? '?' + params.toString() : ''}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          return { cut_without_pauses: [], max_without_pauses: [], merged_video_audio: [] };
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error fetching download links:', error);
      return { cut_without_pauses: [], max_without_pauses: [], merged_video_audio: [] };
    }
  };

  // Метод для получения клипов лекции (cut-videos) с метаданными и live-статистикой
  const getProjectClips = async (projectId) => {
    try {
      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/clips`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching project clips:', error);
      return { project_id: projectId, count: 0, clips: [] };
    }
  };

  // Ресинк статусов проекта с диска (обновляет БД, напр. eng auto_translation=done)
  const resyncProjectFromDisk = async (projectId) => {
    const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/sync_diff`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${getAuthToken()}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  };

  // Метод для получения даты последнего изменения файлов по папкам и языкам
  const getFolderLastModified = async (projectId) => {
    try {
      console.log(`[FolderLastModified] Сканирование папок для проекта ${projectId}...`);

      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/folder_last_modified`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          console.warn(`[FolderLastModified] Папка не найдена для проекта ${projectId}`);
          return { folders: {}, summary: { total_folders: 0, languages_found: [] } };
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      console.log(`[FolderLastModified] Результат:`);
      console.log(`  - Папок: ${result.summary?.total_folders}`);
      console.log(`  - Языки: ${result.summary?.languages_found?.join(', ')}`);

      return result;
    } catch (error) {
      console.error('[FolderLastModified] Ошибка:', error);
      return { folders: {}, summary: { total_folders: 0, languages_found: [] } };
    }
  };

  // Метод для получения длительности лекции из files_to_send
  const getLectureDuration = async (projectId) => {
    try {
      console.log(`[LectureDuration] Получение длительности для проекта ${projectId}...`);

      const response = await fetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/lecture_duration`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log(`[LectureDuration] Результат: ${result.duration_formatted}`);
      return result;
    } catch (error) {
      console.error('[LectureDuration] Ошибка:', error);
      return { duration_ms: null, duration_formatted: null };
    }
  };

  // Метод для обновления skip_last_parts
  const updateSkipLastParts = async (projectId, skipLastParts) => {
    try {
      const response = await authFetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}/skip_last_parts`, {
        method: 'POST',
        body: JSON.stringify({ skip_last_parts: skipLastParts }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('[updateSkipLastParts] Ошибка:', error);
      throw error;
    }
  };

  // Метод для удаления проекта (лекции) с диска и из БД
  const deleteProject = async (projectId) => {
    try {
      const response = await authFetch(`https://translation-manag-server.dev.torsunov.pro/projects/${projectId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        let detail = `HTTP error! status: ${response.status}`;
        try {
          const errBody = await response.json();
          if (errBody.detail) detail = errBody.detail;
        } catch (_) {}
        throw new Error(detail);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error deleting project:', error);
      throw error;
    }
  };

  // Метод для загрузки полных данных конкретного проекта (lazy loading)
  const loadProjectDetails = async (projectId) => {
    try {
      const fullProjectData = await fetchProjectById(projectId);

      if (fullProjectData) {
        // Обновляем проект в существующем списке
        setData(prevData => {
          return prevData.map(project => {
            if (project.id === projectId || project._id === projectId) {
              return {
                ...project,
                parts: processParts(fullProjectData.parts || []),
                detailsLoaded: true
              };
            }
            return project;
          });
        });

        return fullProjectData;
      }

      return null;
    } catch (error) {
      console.error('Error loading project details:', error);
      return null;
    }
  };

  return (<>
    <Context.Provider
      value={{
        state: {
          ready,
          currentPage,
          pageSize,
          isLoading,
          hasNextPage: currentPage < totalPages,
          hasPrevPage: currentPage > 1,
          langsShown,
          setLangsShown,
          searchQuery,
          sortField,
          sortOrder,
          assigneeFilter,
          hasFinalVideoFilter,
          translatedFilter,
          stageFilter,
          stageLang,
          stageExclusive,
          selectedIds,
        },
        people: people,
        totalPages,
        projects: projects,
        data: data,
        handles: {
          setData,
        },
        getProjectsByHandle,
        getProjectById,
        fetchData,
        fetchProjectById,
        fetchPeople,
        getProjectsByName,
        getProjectParts,
        getProjectLanguages,
        getProjectTaskStatuses,
        refreshData,
        refreshProject,
        processParts,
        fetchTotalPages,
        fetchProjectsByPage,
        fetchProjectsWithFilters,
        changePageSize,
        getPaginationInfo,
        nextPage,
        prevPage,
        goToPage,
        updateTaskStatus,
        updateTaskAssignee,
        bulkAssignTaskType,
        bulkUpdateStatus,
        fetchProjectFullData,
        handleSearch,
        handleSort,
        handleAssigneeFilter,
        resetFilters,
        handleFinalVideoFilter,
        handleTranslatedFilter,
        handleStageFilter,
        handleStageLang,
        handleStageExclusive,
        toggleSelect,
        selectPageIds,
        clearSelection,
        selectAllMatchingFilter,
        massProcess,
        handleLangFilter,
        loadProjectDetails,
        splitVideo,
        createFolderTranslateAndSynt,
        getTaskStatus,
        folderMergeWavsAndVideo,
        cutWithoutPauses,
        createMaxWithoutPausesVideo,
        getDownloadLinks,
        getProjectClips,
        resyncProjectFromDisk,
        getFolderLastModified,
        getLectureDuration,
        syncLectureData,
        getLectureDataWithSync,
        scanLectureOnDisk,
        deleteProject,
        updateSkipLastParts,
      }}
    >
      {children}
    </Context.Provider>
  </>
  )

}

const Consumer = Context.Consumer;

export { Context, Provider, Consumer };
